import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";
import { Loader2, Shield } from "lucide-react";

export default function AdminLogin() {
  const { branding, loginAdmin } = useApp();
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { password: pw });
      loginAdmin(data.token);
      navigate("/admin/panel");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Contraseña incorrecta");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-brand-navy flex items-center justify-center p-4">
      <form onSubmit={submit} className="bg-white rounded-3xl shadow-2xl p-8 sm:p-10 w-full max-w-sm">
        <div className="flex justify-center mb-4">{branding?.logo_url && <img src={branding.logo_url} alt="Repsol" className="h-10" />}</div>
        <h1 className="text-2xl font-black brand-navy text-center flex items-center justify-center gap-2"><Shield size={22} /> Administración</h1>
        <p className="text-center text-slate-500 mt-2 mb-6">Introduce la contraseña.</p>
        <input data-testid="admin-password-input" type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Contraseña" className="w-full rounded-2xl border-2 border-slate-200 focus:border-[#003284] outline-none px-5 py-3.5 transition-colors" autoFocus />
        <button data-testid="admin-login-btn" disabled={loading} className="mt-5 w-full bg-brand-navy text-white font-bold rounded-full py-3.5 hover:bg-[#FF7F27] transition-colors flex items-center justify-center gap-2">{loading ? <Loader2 className="animate-spin" size={18} /> : "Entrar"}</button>
        <button type="button" onClick={() => navigate("/")} className="mt-4 w-full text-sm text-slate-400 hover:brand-navy">Volver a la web</button>
      </form>
    </div>
  );
}
